import moment from 'moment';
export default (data, colIndex, order) => { 
    return data.sort((a, b) => {
        const columnsFloat = [
            14, /*VM_UNIT */
            17, /*VL_TOT */
            18, /*VL_PEND */
            32, /*VL_DESC */
            33 /*VL_LIQ */
        ];
        const columnsInt = [
            0, /*NR_PC */
            1, /*ID_PROD */
            2, /*CD_NUM */


            9, /*QT_ITEM */
            10, /*QT_ENTRG */
            11, /*QT_PEND */
            12, /*ID_PESSOA */

            15, /*VP_IPI */
            16, /*QT_PREV */
            19, /*QD_VOL_PEND */
            20, /*QT_AGENDA */
            21, /*QT_VOL_AGENDA */
            25, /*CD_PAGTO */
            26, /*CD_FIL_ENTRG */
            28, /*IQ1 */
            29, /*NCM */
            30, /*VM_PENALZ_AGENDA */
        ];
        const columnsDate = [
            5, /*DT_EMIS */
            6, /*DT_ENTR */
            7, /*DT_PREV_ENTRG */
            8 /*DT_AGENDADA */
        ];
        
        //Float
        if (!!columnsFloat.find(element => element === colIndex)) 
        {
            let va = parseFloat(a.data[colIndex].replace(".","").replace(",",".").replace("R$ ",""));
            let vb = parseFloat(b.data[colIndex].replace(".","").replace(",",".").replace("R$ ",""));
            return (va < vb ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        } 
        //Inteiro
        else if (!!columnsInt.find(element => element === colIndex)) 
        {
            return (parseInt(a.data[colIndex]) < parseInt(b.data[colIndex]) ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
        //Date
        else if (!!columnsDate.find(element => element === colIndex)) 
        {
            let va = "";
            let vb = "";
            if (a.data[colIndex] !== "")
                va = new Date(moment(a.data[colIndex]+' 12:00:00',"DD/MM/YYYY hh:mm:ss").format("l"));
            if (b.data[colIndex] !== "")
                vb = new Date(moment(b.data[colIndex]+' 12:00:00',"DD/MM/YYYY hh:mm:ss").format("l"));
            return ((va < vb) || (va === "") ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
        //String ou Outros
        else { 
            return (a.data[colIndex] < b.data[colIndex] ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
    });
};
